import { styled } from '@mui/material/styles';
import { Box, Stack } from '@mui/material';
import { SpaceMd } from '@nxt-costco-com/forge-design-tokens';

export const popupConsentBannerSx = {
    maxWidth: '1440px',
    minWidth: ['-webkit-fill-available', '-moz-available', 'fill-available'],
    background: 'white',
    boxShadow: '-2px -2px 8px 0px rgba(0, 0, 0, 0.25)',
    paddingLeft: SpaceMd,
    paddingRight: SpaceMd,
    marginLeft: 'auto',
    marginRight: 'auto',
};

export const StyledBoxBannerContent = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: '24px',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '1440px',
    paddingLeft: SpaceMd,
    paddingRight: SpaceMd,
    justifyContent: 'space-between',
    width: ['-webkit-fill-available', '-moz-available', 'fill-available'],
    [theme.breakpoints.down(736)]: {
        flexDirection: 'column',
    },
}));
export const StyledBoxPolicyText = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: ['-webkit-fill-available', '-moz-available', 'fill-available'],
}));

export const StyledButtonStack = styled(Stack)(({ theme }) => ({
    maxWidth: '343px',
    minWidth: '216px',
    width: ['-webkit-fill-available', '-moz-available', 'fill-available'],
    alignSelf: 'flex-start',
    [theme.breakpoints.down(736)]: {
        alignSelf: 'center',
    },
}));

export const bannerTitleSx = {
    maxWidth: '1440px',
    justifyContent: 'start',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: SpaceMd,
    paddingRight: SpaceMd,
};

export const buttonSX = {
    maxWidth: '343px',
    width: ['-webkit-fill-available', '-moz-available', 'fill-available'],
};
export const ErrorStyledButtonStack = styled(StyledButtonStack)(({ theme }) => ({
    [theme.breakpoints.down(736)]: {
        display: 'none',
    },
}));
export const notificationSx = {
    width: ['-webkit-fill-available', '-moz-available', 'fill-available'],
};
